/**
 * @generated SignedSource<<bb4976f73b299789e7778f5433c23a90>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterDimensions_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_itemSearch">;
  readonly " $fragmentType": "SbRespRefineMenuFilterDimensions_itemSearch";
};
export type SbRespRefineMenuFilterDimensions_itemSearch$key = {
  readonly " $data"?: SbRespRefineMenuFilterDimensions_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuFilterDimensions_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuFilterDimensions_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "5e1268eefe3c5705cbcbd04f966defe2";

export default node;
